import { useLatest } from './useLatest';
import { useCallback, useState } from 'react';

export const useOptionallyControlledValue = <T extends unknown>(
  defaultValue?: T | (() => T),
  suppliedValue?: T | (() => T),
  onChange?: (next: T) => void
): [T, (next: T) => void] => {
  const onChangeLatest = useLatest(onChange);

  const [internalValue, setInternalValue] = useState<T>(defaultValue);
  const value =
    suppliedValue != null
      ? typeof suppliedValue === 'function'
        ? (suppliedValue as () => T)()
        : suppliedValue
      : internalValue;

  const handleChange = useCallback((next: T) => {
    setInternalValue(next);
    onChangeLatest.current && onChangeLatest.current(next);
  }, []);

  return [value, handleChange];
};
